<div class="alert alert-dismissible" [ngClass]="type">
    <ng-content></ng-content>
    <button class="btn-close" (click)="onClose()">
        <mat-icon class="size-auto"><i class="fal fa-times"></i></mat-icon>
    </button>
</div>
